"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var TouchRecord = function TouchRecord(e, t, s, i, o) {
  this.event = e, this.id = t, this.radius = s, this.timestamp = Date.now(), this.x = i, this.y = o;
};

exports.TouchRecord = TouchRecord;